import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'
import { Provider } from 'react-redux';
import store from './store/index';
import { AgencyProvider } from './context/agency';
import { UserProvider } from './context/user';
import App from './App';
// import { MaterialUIControllerProvider } from './pages/AppDetailRedirect/templates/context';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <Suspense>
            {/* <MaterialUIControllerProvider> */}
            <UserProvider>
                <AgencyProvider>
                    <Provider store={store}>
                        <App />
                    </Provider>
                </AgencyProvider>
            </UserProvider>
            {/* </MaterialUIControllerProvider> */}
        </Suspense>
    </React.StrictMode>
);
